<template>
  <div id="resume" class="resume p-3 p-lg-5 container-fluid" data-bs-target="#resume">
    <h1 class="title_resume fw-bold mx-auto">RESUME</h1>
    <!-- Bootstrap Timeline -->
    <section class="bsb-timeline-4 bg-light py-3 py-md-5 py-xl-8">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-10 col-md-12 col-xl-12 col-xxl-12">
            <ul class="timeline">
              <li class="timeline-item right">
                <div class="timeline-body">
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_Siemens_AG.png" alt="Siemens Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Junior Electronics Engineer</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Nov 2025 - now</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Responsible for:</p>
                            <p class="card-text mb-2 mb-md-2"> - Hardware developement of a new Fire Detector Simulator called SimFDnet</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/Siemens+Schweiz+AG/@47.17921,8.51372,207m/data=!3m1!1e3!4m6!3m5!1s0x479aaa594655ee67:0x5ae173f0d98b982f!8m2!3d47.1793577!4d8.5142127!16s%2Fg%2F11h02hxtc" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Zug, CH</a></p>
                            <a href="https://www.siemens.com/ch/de/produkte/building-technologies.html" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website Siemens AG</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item left">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_AMZ.png" alt="AMZ Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Freelancer</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Sep 2025 - Jan 2026</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Responsible for:</p>
                            <p class="card-text mb-2 mb-md-2"> - Computer Box Driverless</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/AMZ+Racing/@47.4053986,8.6296995,293m/data=!3m1!1e3!4m14!1m7!3m6!1s0x479aa1994237f607:0x3e162a4066075902!2sD%C3%BCbendorf,+Innovationspark!8m2!3d47.405445!4d8.630295!16s%2Fg%2F11c6_f2mth!3m5!1s0x479aa18706418831:0x60adce62eefb2ed5!8m2!3d47.4056476!4d8.6313717!16s%2Fg%2F11tc8npfmr" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Dübendorf, CH</a></p>
                            <a href="https://www.amzracing.ch/en/cars/2025" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website AMZ Racing</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item right">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_AMZ.png" alt="AMZ Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Focus Student</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Sep 2024 - Aug 2025</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Responsible for:</p>
                            <p class="card-text mb-0 mb-md-0"> - LV BMS</p>
                            <p class="card-text mb-2 mb-md-2"> - LV Supply</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/AMZ+Racing/@47.4053986,8.6296995,293m/data=!3m1!1e3!4m14!1m7!3m6!1s0x479aa1994237f607:0x3e162a4066075902!2sD%C3%BCbendorf,+Innovationspark!8m2!3d47.405445!4d8.630295!16s%2Fg%2F11c6_f2mth!3m5!1s0x479aa18706418831:0x60adce62eefb2ed5!8m2!3d47.4056476!4d8.6313717!16s%2Fg%2F11tc8npfmr" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Dübendorf, CH</a></p>
                            <a href="https://www.amzracing.ch/en/cars/2025" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website AMZ Racing</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item left">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_HSLU.png" alt="HSLU Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Bachelor EEIT</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Sep 2021 - Jul 2025</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Bachelor's thesis: </p>
                            <p class="card-text mb-0 mb-md-0"> - AMZ Racing</p>
                            <p class="card-text mb-0 mb-md-0">Double specialization:</p>
                            <p class="card-text mb-0 mb-md-0"> - Power electronics & drive systems</p>
                            <p class="card-text mb-2 mb-md-2"> - Mechatronics / Automation / Robotics</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/Hochschule+Luzern+%E2%80%93+Technik+%26+Architektur/@47.0158333,8.3060261,885m/data=!3m1!1e3!4m6!3m5!1s0x478ffa430e972afb:0xbda4fc1ab5e45ab2!8m2!3d47.01428!4d8.3052678!16s%2Fg%2F1232z2k4g?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Horw, CH</a></p>
                            <a href="https://www.hslu.ch/de-ch/technik-architektur/studium/bachelor/elektrotechnik-und-informationstechnologie/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website HSLU EEIT</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item right">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_Autcomp_Automation.png" alt="Autcomp Automation Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Junior Automation Engineer</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Aug 2024 - Apr 2025 (40%)</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Responsible for:</p>
                            <p class="card-text mb-2 mb-md-2"> - Developing automation projects in Siemens TIA portal</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/Autcomp+AG/@46.9731343,8.345835,702m/data=!3m2!1e3!4b1!4m6!3m5!1s0x478ff7417de5a5b3:0x325c0eda5de9263e!8m2!3d46.9731343!4d8.3484153!16s%2Fg%2F1v2jbt_f?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Stansstad, CH</a></p>
                            <a href="https://autcomp.ch/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website Autcomp AG</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item left">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_Murdoch_University.svg" alt="Murdoch University Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Semester Abroad</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Feb 2024 - Jun 2024</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Units attended:</p>
                            <p class="card-text mb-0 mb-md-0"> - PLC Systems</p>
                            <p class="card-text mb-0 mb-md-0"> - Power System Modelling and Analysis</p>
                            <p class="card-text mb-2 mb-md-2"> - Python Programming</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/Murdoch+University/@-32.068304,115.8246176,3393m/data=!3m1!1e3!4m6!3m5!1s0x2a32a2beda13da81:0x8afb831e14ef14da!8m2!3d-32.0679659!4d115.8352366!16s%2Fm%2F0dl5q6w?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Perth, Australia</a></p>
                            <a href="https://www.murdoch.edu.au/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website Murdoch University</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item right">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_Repair_Cafe.png" alt="Repair Cafe Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Voluntary Work</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Nov 2023 - Apr 2024</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Responsible for:</p>
                            <p class="card-text mb-2 mb-md-2"> - Repairing broken electronics and household items</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/Repair+Caf%C3%A9+Luzern/@47.0413416,8.304244,701m/data=!3m2!1e3!4b1!4m6!3m5!1s0x478ffb2787f0f4e3:0x3e9d71dda80fe247!8m2!3d47.0413416!4d8.3068189!16s%2Fg%2F11vbypjxsp?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Lucerne, CH</a></p>
                            <a href="https://www.repair-cafe-luzern.ch/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website Repair Café</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item left">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_HT_Infraserv.png" alt="HT Infraserv Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Electrical Planner</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Aug 2022 - Sep 2023 (20%)</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Responsible for:</p>
                            <p class="card-text mb-2 mb-md-2"> - Developing electrical plans, schemes, and tenders</p>
                            <p class="card-text mb-0 mb-md-0"><a class="text-decoration-none"><i class="bi bi-geo-alt"></i> Entlebuch, CH</a></p>
                            <a href="https://ht-infraserv.ch/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website HT-Infraserv</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item right">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_TopShop.svg" alt="TopShop Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Student Help</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Nov 2020 - Jul 2021 (20%)</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Responsible for:</p>
                            <p class="card-text mb-2 mb-md-2"> - Managing the cash desk and restocking</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/TopShop+Rothenburg/@47.092453,8.2507794,767m/data=!3m2!1e3!4b1!4m6!3m5!1s0x478fe3ba9b624b8b:0x5d9544db5cf25e!8m2!3d47.092453!4d8.2533543!16s%2Fg%2F11k0r92fk6?entry=ttu&g_ep=EgoyMDI2MDYwMS4wIKXMDSoASAFQAw%3D%3D" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Rothenburg, CH</a></p>
                            <a href="https://www.topshop.ch/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website TopShop</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item left">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_HSLU.png" alt="HSLU Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Start Bachelor EEIT</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Sep 2021</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.ch/maps/place/Hochschule+Luzern+%E2%80%93+Technik+%26+Architektur/@47.0158333,8.3060261,885m/data=!3m1!1e3!4m6!3m5!1s0x478ffa430e972afb:0xbda4fc1ab5e45ab2!8m2!3d47.01428!4d8.3052678!16s%2Fg%2F1232z2k4g?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Horw, CH</a></p>
                            <a href="https://www.hslu.ch/de-ch/technik-architektur/studium/bachelor/elektrotechnik-und-informationstechnologie/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website HSLU EEIT</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item right">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <h3 class="card-title mb-2 mb-md-2">Vocational Baccalaurete</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Aug 2020 - Jul 2021</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-2 mb-md-2">Prerequisite for a technical or architectural bachelor.</p>
                            <p class="card-text mb-0 mb-md-0"><a href="https://www.google.com/maps?cid=5910793289003547902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAMYASAF&hl=de&source=embed" class="text-decoration-none" target="_blank" rel="noopener noreferrer"><i class="bi bi-geo-alt"></i> Lucerne, CH</a></p>
                            <a href="https://beruf.lu.ch/Berufslehre/Berufslehre_im_Betrieb/Berufsfachschule/berufsbildungszentren/bbzb/BM/TALS" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website BBZB</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item left">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_Network_41.svg" alt="Network 41 Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Electrical Planner</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Jul 2018 - Jul 2020</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0">Responsible for:</p>
                            <p class="card-text mb-0 mb-md-0"> - Developing electrical plans, schemes, and tenders</p>
                            <p class="card-text mb-2 mb-md-2"> - Project meetings with architects and clients</p>
                            <p class="card-text mb-0 mb-md-0"><a class="text-decoration-none"><i class="bi bi-geo-alt"></i> Sursee, CH</a></p>
                            <a href="https://network41.com/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website Network 41 AG</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item right">
                <div class="timeline-body">
                  <div class="timeline-meta">
                  </div>
                  <div class="timeline-content timeline-indicator">
                    <div class="card border-0 shadow">
                      <div class="card-body p-xl-4">
                        <div class="row">
                          <div class="col-md-6 text-center d-flex flex-column justify-content-center">
                            <img src="@/assets/logo_Network_41.svg" alt="Network 41 Logo" class="img-fluid mb-2">
                            <h3 class="card-title mb-2 mb-md-2">Apprenticeship</h3>
                            <h6 class="card-subtitle text-secondary mb-3 mb-md-0">Aug 2014 - Jul 2018</h6>
                          </div>
                          <div class="col-md-6 text-start">
                            <p class="card-text mb-0 mb-md-0"><a class="text-decoration-none"><i class="bi bi-geo-alt"></i> Sursee, CH</a></p>
                            <a href="https://network41.com/" class="text-decoration-none" target="_blank" rel="noopener noreferrer">Website Network 41 AG</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
  name: 'HomeAboutMe',
  props: {
    msg: String,
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    const elements = document.querySelectorAll('.timeline-item.right, .timeline-item.left');
    elements.forEach((element) => {
      const direction = element.classList.contains('right') ? 700 : -700;
      gsap.from(element, {
        x: direction,
        opacity: 0,
        duration: 1,
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse',
        },
      });
    });
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css";
@import "https://unpkg.com/bs-brain@2.0.4/tutorials/timelines/timeline-4/assets/css/timeline-4.css";

.resume {
  background-color: #52796f;
}

.bg-light {
  background-color: #52796f !important;
}

.title_resume {
  font-size: 3rem;
}

.p-10 {
  padding: 7rem !important;
  /* 112px */
}

.timeline-item.right::after {
  border-color: #eb5e28;
}

.timeline-item.left::after {
  border-color: #eb5e28;
}

.timeline-content.timeline-indicator {
  position: relative;
  /* Establish a new stacking context */
  z-index: 2;
  /* Ensure indicators are above the lines */
}

.timeline-item {
  position: relative;
  /* Make sure content is positioned correctly */
  z-index: 1;
}

/* Media query for smartphones (up to 768px wide) */
@media (max-width: 768px) {
  .title_resume {
    padding-top: 3rem;
    padding-bottom: 1.5rem;
  }

  .technology {
    padding-top: 0rem;
    padding-bottom: 1.5rem;
  }

  .interests {
    padding-top: 0rem;
    padding-bottom: 1.5rem;
  }

  .language {
    padding-top: 0rem;
    padding-bottom: 1.5rem;
  }

  .hobbies {
    padding-top: 0rem;
    padding-bottom: 1.5rem;
  }
}
</style>
